<script lang="ts" setup>
  import { useField } from 'vee-validate';
  import { errorClass } from '../InputWrapper';
  import {
    RadioGroupOrientation,
    type RadioGroupProps,
  } from './RadioGroup.types';
  import RadioGroup from './RadioGroup.vue';

  const { options, label, defaultValue, name, orientation } = defineProps<
    RadioGroupProps & { name: string }
  >();

  const { handleChange, meta, errorMessage, value, setValue } =
    useField<string>(name);

  // Initialize field with defaultValue if provided and value is not set
  if (defaultValue && !value.value) {
    setValue(defaultValue);
  }

  const onFieldChange = (newValue: string) => {
    handleChange(newValue);
  };
</script>

<template>
  <div>
    <RadioGroup
      :options="options"
      :label="label"
      :model-value="value"
      @update:modelValue="onFieldChange"
      :default-value="defaultValue"
      :orientation="orientation ?? RadioGroupOrientation.horizontal"
      :name="name"
    >
      <template v-for="(_, slot) in $slots" v-slot:[slot]="scope" :key="slot">
        <slot :name="slot" v-bind="scope" />
      </template>
    </RadioGroup>
    <p v-if="errorMessage && meta.touched" :class="errorClass">
      {{ errorMessage }}
    </p>
  </div>
</template>
